export default __webpack_public_path__ + "static/media/Artist8.d9094918.svg";